export const instagram = "https://www.instagram.com/obro_soft/"
export const linkedin = "https://tr.linkedin.com/company/obrosoft"